export const ensureDate = (value) => {
    if (!value) {
        return null;
    }
    if (value instanceof Date) {
        const cloned = new Date(value.getTime());
        return Number.isNaN(cloned.getTime()) ? null : cloned;
    }
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
};

export const normalizeInterval = (date, minutes = 30) => {
    const base = ensureDate(date);
    if (!base) {
        return null;
    }
    const rounded = new Date(base.getTime());
    const remainder = rounded.getMinutes() % minutes;
    if (remainder !== 0) {
        rounded.setMinutes(rounded.getMinutes() + (minutes - remainder));
    }
    rounded.setSeconds(0, 0);
    return rounded;
};

export const defaultTimedEventWindow = (minutes = 60) => {
    const now = new Date();
    const start = normalizeInterval(now) || new Date(now.getTime());
    const end = new Date(start.getTime());
    end.setMinutes(end.getMinutes() + minutes);
    return { start, end };
};

export const toIsoStringOrEmpty = (value) => {
    const date = ensureDate(value);
    return date ? date.toISOString() : "";
};

export const toLocalISOString = (value) => {
    const date = ensureDate(value);
    if (!date) {
        return "";
    }
    const offsetMinutes = date.getTimezoneOffset();
    const adjusted = new Date(date.getTime() - offsetMinutes * 60000);
    return adjusted.toISOString();
};

export const toDateInputValue = (value) => {
    const iso = toLocalISOString(value);
    return iso ? iso.slice(0, 10) : "";
};

export const toDateTimeInputValue = (value) => {
    const iso = toLocalISOString(value);
    return iso ? iso.slice(0, 16) : "";
};
